export const UNKNOWN = "UNKNOWN"
export const THIS_INTERRUPTS_ACTION = "The current action will be interrupted"
export const ERROR_OCCURED = "An error occurred. Please try again later"
export const ERROR_OCCURED_DURING_LOOP = "An error occurred during test"
export const ERROR_OCCURED_SENDING_RESULTS =
  "An error occurred while sending the results"
export const TERMS_AND_CONDITIONS = "Terms and conditions text"
export const UUID = "RMBTuuid"
export const RMBTTermsV6 = "RMBTTermsV6"
export const TERMS_VERSION = "RMBTTermsVersion"
export const RESULT_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss"
export const TEST_FINISHED_ANNOUNCEMENT =
  "The test has finished. Showing the results page."
export const LOCATION_PERMISSION_DENIED =
  "RTR_NETZTEST_LOCATION_PERMISSION_DENIED"
